import {defaultPagination} from "@/services/pagination";
import {listUsers} from "@/services/api/app/entraId/users";
import {refresh, exportUsersSnapshot} from "@/services/api/app/office/entraId/seats";

const defaultState = () => ({
  users: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false,
  },
  search: '',
});

export default {
  namespaced: true,

  actions: {
    list({commit, state}) {
      return listUsers({
        pagination: state.pagination,
        searchTerm: state.search || ''
      })
        .then(({result, pagination}) => {
          commit('setUsers', result);
          commit('setPagination', pagination);
        })
        .catch(error => {
          console.error("Failed to list users:", error);
          throw error;
        });
    },
    refresh() {
      return refresh();
    },
    exportSnapshot({state}) {
      return exportUsersSnapshot(state.search || null, {
        pageSize: 0,
        pageNumber: 1,
        sortBy: 'displayName',
        sortDescending: false,
      });
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false,
      };
    },
    setSearch(state, search) {
      state.search = search || '';
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  state: defaultState(),
}
